import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { getResetStateMutation } from "@/store/helpers/helpers";

const getDefaultState = () => ({
  user: null,
  userRoles: [],
  email: null,
  domain: null,
  userInfo: null,
  userProfileTabState: "View",
  newPassword: null,
  userConnections: [],
  firstLogin: false
});

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    resetState: getResetStateMutation(getDefaultState)
  },
  actions,
  getters
};
